import { Directive, Input, OnInit } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
    standalone: true,
    selector: '[appDisableControl]',
})
export class DisableControlDirective implements OnInit {
    private disable: boolean;

    @Input() set appDisableControl(condition: boolean) {
        if (condition !== this.disable) {
            this.toggleForm(condition);
        }
        this.disable = condition;
    }

    constructor(private ngControl: NgControl) {}

    ngOnInit(): void {
        this.toggleForm(this.disable);
    }

    toggleForm(condition: boolean): void {
        const action = condition ? 'disable' : 'enable';
        this.ngControl?.control && this.ngControl?.control[action]();
    }
}
